import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom, Observable } from 'rxjs';
import { environment } from '@environment';

@Injectable({
  providedIn: 'root'
})
export class FileService {
    // baseUrl: string = environment.ApiBase + 'usnrfilestream/';
    private fileUrl: string = environment.ApiBase + "file";

    constructor(private _http: HttpClient) { }

    // i.e. getFile("k2-00007.gif", "DVaultThumbnail", "Image")
    getFilestream(type: string, fileName: string, fileType: string, streamType: string, asBytes: boolean = false): Observable<any> {
        const params: HttpParams = new HttpParams({ fromObject: {
            "fileName": fileName,
            "fileType": fileType,
            "streamType": streamType
        }});

        let headers: HttpHeaders;
        if (asBytes) {
            headers = new HttpHeaders({ "Content-Type": "application/octet-stream" });
            return this._http.get(`${this.fileUrl}/${type}`, { params: params, headers: headers });
        } else {
            return this._http.get(`${this.fileUrl}/${type}`, { params: params, responseType: "blob" });
        }
    }

    async getFilestreamExists(type: string, fileName: string, fileType: string, streamType: string): Promise<any> {
        const params: HttpParams = new HttpParams({ fromObject: {
            "fileName": fileName,
            "fileType": fileType,
            "streamType": streamType
        }});

        let headers: HttpHeaders;
        return firstValueFrom(this._http.get(`${this.fileUrl}/${type}/availability`, { params: params, headers: headers }));
    }

    static b64toBlob(b64Data: string, contentType: string, sliceSize: number): Blob {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;

        const byteCharacters: string = atob(b64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice: string = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray: Uint8Array = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        const blob: Blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }


    // getFilestreamFile(fileName: string, streamType: string): Observable<any> {
    //     const params = new HttpParams({ encoder: new CustomUriEncoder() })
    //         .set('fileName', fileName);

    //     const headers: HttpHeaders = new HttpHeaders({ "Content-Type": "application/octet-stream" });
    //     return this._http.get(environment.ApiBase + 'usnrfilestream/' + streamType, { params: params, headers: headers });
    // }


    // this._fileService.getSharePointFile(part.FilePath).subscribe(
    //             (response: any) => {
    //                 if (!response) {
    //                     alert('File does not exist.');
    //                     return;
    //                 }

    //                 // const blobContents: Blob = this._fileService.b64toBlob(response, 'application/octet-stream', 512);
    //                 const blobContents: Blob = this._fileService.b64toBlob(response, 'application/pdf', 512);
    //                 // saveAs(blobContents, `${part.DrawingFile}.${part.DrawingType}`);

    //                 const drawingUrl: string = URL.createObjectURL(blobContents);
    //                 // window.open(drawingUrl +
    //                 //     '?x=' + new Date().getTime(), '_blank', 'height=800,width=750,resizable=1');
    //                 window.open(drawingUrl, '_blank', 'height=800,width=750,resizable=1');
}
